<template>
	<div>
		<div style="text-align: left;">
			<el-button size="small" type="primary" icon="el-icon-plus" @click="addCom">新增</el-button>
			<el-button size="small" type="primary" icon="el-icon-refresh" @click="restart">重启软件</el-button>
		</div>
		<div class="comStyle">
			<el-table
			  :data="tableData"
			  @selection-change="handleSelectionChange"
			  :row-class-name="tableRowClassName"
			  size="mini"
			  :span-method="arraySpanMethod"
			  border
			  stripe
			  style="width: 40%; margin-top: 10px">
			  <el-table-column
			          type="selection"
			          width="30">
			  </el-table-column>
			  <el-table-column
				prop="id"
				label="编号" width="80">
			  </el-table-column>
			  <el-table-column
				prop="comId"
				label="串口编号" width="80">
			  </el-table-column>
			  <el-table-column
				prop="comName"
				label="串口名称" >
			  </el-table-column>
			  <!-- <el-table-column
				prop="comId"
				label="lufft编号" >
			  </el-table-column> -->
			  <el-table-column
				prop="adrrId"
				label="从机地址" >
			  </el-table-column>
			 
			 
			</el-table>
			</div>
			<div style="text-align: left;">
				<el-button size="small" type="danger" icon="el-icon-check" @click="updateCom"
				:disabled="multipleSelection.length==0">编辑</el-button>
				<el-button size="small" type="danger" icon="el-icon-minus" @click="deleteCom"
				:disabled="multipleSelection.length==0">删除</el-button>
			</div>
			<el-dialog
				  :title="namelg"
				  :visible.sync="dialogVisible"
				  
				  width="30%">
			 <el-form :rules="rules"
				  ref='updatePos' label-position="right" label-width="110px"
				  :model="updatePos" class="comDia">
				  <span>
				  <el-form-item label="编号" >
				  <el-input class="updatePosInput" size="small" v-model="updatePos.id" 
				  disabled=false ></el-input>
				  </el-form-item>
					<el-form-item label="串口编号" prop="comId">
				  <el-input class="updatePosInput" size="small" v-model="updatePos.comId" 
				  disabled=false></el-input>
				  </el-form-item>
				  <el-form-item label="串口名称" prop="comName">
					  <el-select v-model="updatePos.comName" placeholder="请选择串口" @change="comChange">
					       <el-option :label="child.comName"  v-for="(child,index) in dataCom" v-if="!child.mode" 
						   :key="index" :value="child.id"></el-option>
					        
					  </el-select>
				  <!-- <el-input autofocus="off" class="updatePosInput" size="small" v-model="updatePos.comName"></el-input> -->
				  </el-form-item>
				  </span>
				 <!-- <el-form-item label="lufft编号" prop="comId">
				  <el-input autofocus="off" class="updatePosInput" size="small" v-model="updatePos.comId"></el-input>
				  </el-form-item> -->

				  <el-form-item label="从机地址" prop="adrrId">
				  <!-- <el-input autofocus="off" class="updatePosInput" size="small" v-model="updatePos.adrrId"></el-input> -->
					  <el-select v-model="updatePos.adrrId" placeholder="请选择从机地址"  @change="lufftChange">
						   <el-option :label="child.adrr"  v-for="(child,index) in dataLufft"  
											   :key="index" :value="child.adrr"></el-option>
							
					  </el-select>
				  </el-form-item>

				  
				  <el-form-item>
				  <el-button size="small" @click="dialogVisible = false">取 消</el-button>
				  <el-button size="small" type="primary" @click="doUpdate(updatePos)">确 定</el-button>
				  </el-form-item>
			  </el-form>
			  
		  </el-dialog>
	</div>
</template>

<script>
	import { Message } from 'element-ui';
	export default {
		name: "ComLufft",	
		data() {
		  return {
			namelg:"更新串口配置从机",
		    tableData: [],
			dataRep:[],
			dataCom:[],
			dataLufft:[],
			dialogVisible: false,
			len:0,
			showf:true,
			multipleSelection: [],
			updatePos: {
				id:'',
				comId:'',
			    comName:'',
			    //comId:'',
				adrrId: '',
				
				
			},
			rules:{
				id: [
					{ required: true,message: '编号不能为空！', trigger: 'blur' }
				],
				comId:  [
					{ required: true, message: '串口编号不能为空！',trigger: 'blur' }
				],
				comName:  [
					{ required: true, message: '串口名称不能为空！',trigger: 'blur' }
				],
				
				adrrId:  [
					{ required: true,message: '从机地址不能为空！', trigger: 'blur' }
				],
				
			}
		  };
		},
		mounted() {
			this.initLoad();
			this.getCom();
			this.getLufft();
		},
		methods: {
			tableRowClassName({row, rowIndex}) {
				if ((rowIndex%2) == 1) {
				  return 'success-row';
				} 
				return '';
			  },
			lufftChange(val){
				debugger
			},
			comChange(val){
				
				this.updatePos.comId=val;
			},
			getCom(){
				this.getRequest("/com/ma/").then(resp => {
					if(resp)
					this.dataCom=resp;
				})
			},
			getLufft(){
				this.getRequest("/com/ma/lufft").then(resp => {
					debugger
					 var arr=[],jsonD={},datal=[],j=0;    //定义一个临时数组 
					 
					if(resp){
						
					   for(var i = 0; i < resp.length; i++){    //循环遍历当前数组 
						   //判断当前数组下标为i的元素是否已经保存到临时数组 
						   //如果已保存，则跳过，否则将此元素保存到临时数组中 
						   if(arr.indexOf(resp[i].adrr) == -1){ 
							   arr.push(resp[i].adrr); 
							   jsonD=resp[i];
							   datal[j]=jsonD;
							   j++;
						   } 
					   }  
					   
					   this.dataLufft=datal;
					}
					
				})
			},
			arraySpanMethod({ row, column, rowIndex, columnIndex }){
				
				//var i=0;
				/* this.dataRep.forEach(i=>{
					
				}) */
				// var ln=this.dataRep[this.len];
				// if(rowIndex==ln&&columnIndex == 1){
				// 	this.len++;
				// 	ln=this.dataRep[this.len];
				// }
				// else if(rowIndex==0)
				// this.len=0;
				//  if (columnIndex == 1||columnIndex == 2) {
				// 	if(rowIndex%ln==0){
				// 		debugger
				// 		return {
				// 		  rowspan:ln,
				// 		  colspan:1,
						  
				// 		};
				// 	}
				// 	else{
				// 		return {
				// 		  rowspan:0,
				// 		  colspan:0
				// 		};
				// 	}
				          
				// } 
				
				      
			},
			addCom(){
				this.namelg='保存串口配置从机'
				this.updatePos.id='';
				this.updatePos.comId='';
				this.updatePos.comName='';
				//this.updatePos.comId='';
				this.updatePos.addr='';
				
				
				this.dialogVisible=true;
			},
			restart(){
				this.$confirm('此操作重启软件', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					debugger
					this.putRequest("/com/ma/",null).then(resp => {
						// if (resp.msg.indexOf("失败")==-1) {
						// 	debugger
						// 	Message.success({message:resp.msg});
						// }else{
						// 	Message.error({message:resp.msg});
						// }
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消重启'
					});
				});

			},
			doUpdate(){
				this.$refs.updatePos.validate((valid) => {
					if (valid) {
						if(this.updatePos.id==''){
							this.$confirm('此操作新建一条记录', '提示', {
							        confirmButtonText: '确定',
							        cancelButtonText: '取消',
							        type: 'warning',
							}).then(() => {
							    debugger
							    this.postRequest("/com/ma/cl",this.updatePos).then(resp => {
							        if (resp) {
							            this.initLoad();
										this.dialogVisible=false;
							        }
							    })
							}).catch(() => {
							    this.$message({
							        type: 'info',
							        message: '已取消保存'
							    });
							});
						}else{
							this.$confirm('此操作修改ID=【' + this.updatePos.id + '】的记录?', '提示', {
							        confirmButtonText: '确定',
							        cancelButtonText: '取消',
							        type: 'warning',
							}).then(() => {
							    
							    this.postRequest("/com/ma/cl",this.updatePos).then(resp => {
							        if (resp) {
							            this.initLoad();
										this.dialogVisible=false;
							        }
							    })
							}).catch(() => {
							    this.$message({
							        type: 'info',
							        message: '已取消修改'
							    });
							});
						}
					} else {
						console.log('请输入所有字段！');
						return false;
					}
				})
				
				
			},
			updateCom(){
				if(this.multipleSelection.length!=1){
					this.$message({
					    type: 'warning',
					    message: '请选择单条数据编辑！'
					});
				}else{
					this.namelg='更新串口配置从机'
					this.multipleSelection.forEach(item => {
						this.updatePos.id=item.id;
						this.updatePos.comId=item.comId;
						this.updatePos.comName=item.comName;
						//this.updatePos.comId=item.comId;
						this.updatePos.adrrId=item.adrrId;
						
						
						
					});
					this.dialogVisible=true;
					
					
				}
			},
			deleteCom(){this.$confirm('此操作将永久删除【' + this.multipleSelection.length + '】条记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let ids = '?';
                    this.multipleSelection.forEach(item => {
                        ids += 'ids=' + item.id + '&';
                    })
                    this.deleteRequest("/com/ma/cl" + ids).then(resp => {
                        if (resp) {
                            this.initLoad();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
			initLoad(){
				this.getRequest("/com/ma/cl").then(resp => {
				    //this.loading = false;
				    if (resp) {
						//debugger
						// var tData=[18],dRep=[10];
						// //this.dataRep=resp;
						// var rp=resp;
						// var i=0,j=0;
						// rp.forEach(item=>{
						// 	dRep[j]=item.luffts.length;
						// 	j++;
						// 	item.luffts.forEach(it=>{
						// 		var ttd={};
						// 		ttd.id=item.id;
						// 		ttd.comName=item.comName;
						// 		//ttd.comId=it.id;
						// 		ttd.adrrId=it.adrrId;
						// 		tData[i]=ttd;
						// 		i++;
						// 	})
							
						// });
				        this.tableData = resp;
						//this.dataRep=dRep;
				    }
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
		  
				
		 
		}
	}
</script>

<style>
	.comStyle{
		margin-bottom: 8px
	}
	.updatePosInput {
	    width: 200px;
	    margin-left: 10px;
	}
	.comDia{
		/* text-align: left; 
		margin-left: 8px; */
		margin-bottom: 8px;
		padding: 15px 35px 15px 35px;
		
	}
	.el-table .success-row {
	    background: #f0f9eb;
	  }
</style>

